export default __webpack_public_path__ + "static/media/2025-educatia-la-sat-2.af82178f.jpg";